import ConsoleLogEntry from './ConsoleLogEntry';

export default class ConsoleLogger {
    constructor(options = {}) {
        this.logTypes = options.logTypes || ['log', 'warn', 'error', 'info'];
        this.maxEntries = options.maxEntries || 1000;
        this.logs = [];
        this._originals = {};
        this._patchConsole();
    }

    _patchConsole() {
        this.logTypes.forEach(type => {
            this._originals[type] = console[type];
            console[type] = (...args) => {
                this._storeLog(type, args);
                this._originals[type](...args);
            };
        });
    }

    _storeLog(type, args) {
        const entry = new ConsoleLogEntry(type, args);
        this.logs.push(entry);

        if (this.logs.length > this.maxEntries) {
            this.logs.shift();
        }
    }


    getLogs(filterType = null) {
        return filterType ? this.logs.filter(l => l.type === filterType) : this.logs;
    }

    clear() {
        this.logs = [];
    }

    exportJSON(pretty = true) {
        return JSON.stringify(this.logs.map(e => e.toJSON()), null, pretty ? 2 : 0);
    }

    getFirestoreSafeLogs() {
        return this.logs.map(e => e.toFirestore());
    }


    stop() {
        this.logTypes.forEach(type => {
            if (this._originals[type]) {
                console[type] = this._originals[type];
            }
        });
    }

}
